module.exports = __webpack_public_path__ + "static/media/VectorPointAndamento14.4b267aa3.svg";